// Umaang — reference data for profile dropdowns
// Curated lists (India-first). Backend accepts strings so lists can grow freely.

export const RELIGIONS = [
  "Hindu",
  "Muslim",
  "Sikh",
  "Christian",
  "Jain",
  "Buddhist",
  "Parsi / Zoroastrian",
  "Jewish",
  "Bahá'í",
  "Spiritual",
  "Inter-religion",
  "No religion",
  "Other",
];

export const CASTES = {
  Hindu: [
    "Brahmin","Kshatriya","Vaishya","Kayastha","Rajput","Jat","Yadav","Gujjar","Kurmi",
    "Reddy","Naidu","Nair","Iyer","Iyengar","Marwari","Agrawal","Maheshwari","Baniya",
    "Kamma","Kapu","Vokkaliga","Lingayat","Kumhar","Sonar","Sindhi","Punjabi","Bengali Hindu",
    "Maratha","SC","ST","OBC","Other",
  ],
  Muslim: ["Sunni","Shia","Bohra","Ismaili","Ansari","Sheikh","Syed","Pathan","Mughal","Khan","Other"],
  Sikh: ["Jat Sikh","Khatri","Arora","Ramgarhia","Ravidasia","Ahluwalia","Kamboj","Other"],
  Christian: ["Roman Catholic","Protestant","Orthodox","Syrian","Anglican","Baptist","Pentecostal","Other"],
  Jain: ["Digambar","Shwetambar","Terapanthi","Sthanakvasi","Other"],
  Buddhist: ["Theravada","Mahayana","Vajrayana","Navayana","Other"],
  Parsi: ["Parsi","Irani","Other"],
  Other: ["Other"],
};

export const CASTES_ALL = Array.from(new Set(Object.values(CASTES).flat()));

export const EDUCATION = [
  "Below High School","High School (10th)","Higher Secondary (12th)",
  "Diploma","ITI / Trade Certificate","Nursing Diploma",
  "B.A.","B.Com.","B.Sc.","B.B.A.","B.C.A.","B.Ed.","B.El.Ed.","BFA","BFT","B.Pharma","BHM",
  "B.Tech / B.E.","B.Arch","MBBS","BDS","BAMS","BHMS","BUMS","BVSc","B.PT (Physiotherapy)","LLB",
  "CA (Chartered Accountant)","CS (Company Secretary)","CMA / ICWA","CFA",
  "M.A.","M.Com.","M.Sc.","MBA","MCA","M.Ed.","MFA","M.Pharma","MHM",
  "M.Tech / M.E.","M.Arch","MD","MS","MDS","M.PT","LLM",
  "M.Phil.","Ph.D.","Post Doctorate",
  "Diploma (Post-graduate)","PG Diploma","Certificate Course","Other",
];

export const PROFESSIONS = [
  "Software Engineer","Software Developer","Full-Stack Developer","Data Scientist","Data Analyst",
  "DevOps Engineer","Cybersecurity Analyst","AI/ML Engineer","Product Manager","Product Designer",
  "UI/UX Designer","Graphic Designer","Content Writer","Copywriter","Digital Marketer","SEO Specialist",
  "Business Analyst","Consultant","Management Consultant","Investment Banker","Banker","Financial Analyst",
  "Chartered Accountant","Company Secretary","CFO","Tax Consultant","Auditor","Actuary",
  "Doctor (MBBS/MD)","Dentist","Surgeon","Ayurvedic Doctor","Homeopath","Nurse","Pharmacist","Physiotherapist",
  "Lab Technician","Radiologist","Veterinarian","Medical Sales Rep",
  "Civil Engineer","Mechanical Engineer","Electrical Engineer","Electronics Engineer","Chemical Engineer",
  "Aerospace Engineer","Automobile Engineer","Petroleum Engineer","Mining Engineer","Industrial Engineer",
  "Architect","Interior Designer","Urban Planner","Landscape Architect",
  "Teacher (Primary)","Teacher (Secondary)","Professor","Lecturer","Assistant Professor","Principal",
  "Researcher","Scientist","Librarian","Educational Counsellor",
  "Lawyer","Advocate","Judge","Legal Advisor","Paralegal","Notary",
  "Chartered Engineer","Government Officer (IAS/IPS/IFS)","Civil Services","Defence Officer","Army Officer",
  "Navy Officer","Air Force Officer","Police Officer","Firefighter","Customs Officer","RBI/PSU Officer",
  "Journalist","Reporter","Editor","News Anchor","Photographer","Videographer","Filmmaker","Actor",
  "Musician","Singer","Composer","Dancer","Choreographer","Artist","Painter","Sculptor",
  "Chef","Sous Chef","Baker","Nutritionist","Dietitian","Hotel Manager","Restaurateur","Sommelier",
  "Pilot","Cabin Crew","Air Traffic Controller","Ground Staff","Merchant Navy","Ship Captain",
  "Entrepreneur / Founder","Business Owner","Self-employed","Freelancer","Consultant (Independent)",
  "Startup Co-founder","Farmer / Agriculturist","Horticulturist","Real Estate Broker","Investor",
  "Sales Executive","Sales Manager","Marketing Manager","Brand Manager","Public Relations",
  "HR Executive","HR Manager","Talent Acquisition","Learning & Development",
  "Operations Manager","Supply Chain Manager","Logistics Manager","Warehouse Manager","Procurement",
  "Retail Manager","Store Owner","Insurance Agent","Loan Officer","Mortgage Advisor","Wealth Manager",
  "Astrologer","Priest / Purohit","Social Worker","NGO Worker","Diplomat","Politician",
  "Fitness Trainer","Yoga Instructor","Sports Coach","Athlete","Cricketer","Footballer",
  "Homemaker","Student","Not working","Retired","Other",
];

export const DIETS = [
  "Vegetarian","Vegan","Eggetarian","Non-vegetarian","Occasionally non-veg",
  "Jain (Satvik)","No onion / No garlic","Halal","Kosher","Pescatarian",
  "Gluten-free","Diabetic-friendly","Other",
];
export const DIET_VALUES = {
  "Vegetarian": "veg", "Vegan": "veg", "Eggetarian": "veg", "Jain (Satvik)": "veg",
  "No onion / No garlic": "veg", "Pescatarian": "non-veg",
  "Non-vegetarian": "non-veg", "Occasionally non-veg": "non-veg",
  "Halal": "non-veg", "Kosher": "non-veg", "Gluten-free": "other",
  "Diabetic-friendly": "other", "Other": "other",
};

export const MARITAL_STATUS = [
  { value: "single", label: "Never married" },
  { value: "divorced", label: "Divorced" },
  { value: "widow", label: "Widowed" },
  { value: "separated", label: "Separated" },
  { value: "annulled", label: "Annulled" },
  { value: "other", label: "Other" },
];

export const MOTHER_TONGUES = [
  "Hindi","English","Punjabi","Gujarati","Marathi","Bengali","Tamil","Telugu","Kannada","Malayalam",
  "Urdu","Odia","Assamese","Sindhi","Konkani","Kashmiri","Nepali","Manipuri","Sanskrit","Rajasthani",
  "Bhojpuri","Awadhi","Maithili","Haryanvi","Kutchi","Tulu","Coorgi","Bodo","Dogri","Santhali","Other",
];

// Age ranges for pickers (18–70)
export const AGES = Array.from({ length: 70 - 18 + 1 }, (_, i) => 18 + i);

export const FAMILY_TYPES = ["Nuclear","Joint","Extended","Living independently","Other"];
export const FAMILY_VALUES = {
  "Nuclear":"nuclear","Joint":"joint","Extended":"joint","Living independently":"nuclear","Other":"other",
};

export const RASHIS = ["Mesha (Aries)","Vrishabha (Taurus)","Mithuna (Gemini)","Karka (Cancer)","Simha (Leo)","Kanya (Virgo)","Tula (Libra)","Vrishchika (Scorpio)","Dhanu (Sagittarius)","Makara (Capricorn)","Kumbha (Aquarius)","Meena (Pisces)"];
export const NAKSHATRAS = [
  "Ashwini","Bharani","Krittika","Rohini","Mrigashira","Ardra","Punarvasu","Pushya",
  "Ashlesha","Magha","Purva Phalguni","Uttara Phalguni","Hasta","Chitra","Swati","Vishakha",
  "Anuradha","Jyeshta","Mula","Purva Ashadha","Uttara Ashadha","Shravana","Dhanishta","Shatabhisha",
  "Purva Bhadrapada","Uttara Bhadrapada","Revati",
];

export const HOBBIES = [
  "Reading","Writing","Cooking","Baking","Gardening","Yoga","Meditation","Running","Cycling",
  "Trekking","Hiking","Travelling","Photography","Painting","Sketching","Music","Singing",
  "Dancing","Playing Guitar","Playing Piano","Playing Tabla","Chess","Cricket","Football","Badminton",
  "Tennis","Swimming","Volunteering","Blogging","Podcasting","Movies","Theatre","Board Games",
  "Video Games","Investing","Coding","Astronomy","History","Learning Languages",
];

// Popular Indian cities — extend anytime
export const CITIES = [
  "Mumbai","Delhi","Bengaluru","Hyderabad","Chennai","Kolkata","Ahmedabad","Pune","Jaipur","Surat",
  "Lucknow","Kanpur","Nagpur","Indore","Thane","Bhopal","Visakhapatnam","Pimpri-Chinchwad","Patna","Vadodara",
  "Ghaziabad","Ludhiana","Agra","Nashik","Faridabad","Meerut","Rajkot","Kalyan-Dombivli","Vasai-Virar","Varanasi",
  "Srinagar","Aurangabad","Dhanbad","Amritsar","Navi Mumbai","Allahabad (Prayagraj)","Ranchi","Howrah","Coimbatore","Jabalpur",
  "Gwalior","Vijayawada","Jodhpur","Madurai","Raipur","Kota","Chandigarh","Guwahati","Solapur","Hubballi-Dharwad",
  "Mysuru","Tiruchirappalli","Bareilly","Aligarh","Tiruppur","Gurugram","Moradabad","Jalandhar","Bhubaneswar","Salem",
  "Warangal","Mira-Bhayandar","Thiruvananthapuram","Bhiwandi","Saharanpur","Guntur","Amravati","Bikaner","Noida","Jamshedpur",
  "Bhilai","Cuttack","Firozabad","Kochi","Nellore","Bhavnagar","Dehradun","Durgapur","Asansol","Rourkela",
  "Nanded","Kolhapur","Ajmer","Gulbarga","Jamnagar","Ujjain","Loni","Siliguri","Jhansi","Ulhasnagar",
  "Jammu","Sangli-Miraj-Kupwad","Mangaluru","Erode","Belgaum","Ambattur","Tirunelveli","Malegaon","Gaya","Jalgaon",
];

export const INCOME_BRACKETS = [
  "< ₹2 LPA","₹2 – 5 LPA","₹5 – 10 LPA","₹10 – 15 LPA","₹15 – 25 LPA","₹25 – 40 LPA","₹40 – 60 LPA","₹60 – 1 Cr","> ₹1 Cr","Prefer not to say",
];

export const EMPLOYMENT_TYPES = [
  "Salaried – Private","Salaried – Government / PSU","Business / Self-employed",
  "Freelancer / Consultant","Entrepreneur / Founder","Working abroad",
  "Not working","Student","Retired","Homemaker","Other",
];

export const STATES = [
  "Andhra Pradesh","Arunachal Pradesh","Assam","Bihar","Chhattisgarh","Delhi","Goa","Gujarat","Haryana",
  "Himachal Pradesh","Jammu & Kashmir","Jharkhand","Karnataka","Kerala","Ladakh","Madhya Pradesh","Maharashtra",
  "Manipur","Meghalaya","Mizoram","Nagaland","Odisha","Puducherry","Punjab","Rajasthan","Sikkim","Tamil Nadu",
  "Telangana","Tripura","Uttar Pradesh","Uttarakhand","West Bengal","Andaman & Nicobar","Chandigarh",
  "Dadra & Nagar Haveli","Daman & Diu","Lakshadweep",
];

export const COUNTRIES = [
  "India","United States","United Kingdom","Canada","Australia","United Arab Emirates","Singapore","Saudi Arabia",
  "Qatar","Kuwait","Oman","Bahrain","Malaysia","New Zealand","Germany","France","Netherlands","Ireland",
  "Nepal","Bangladesh","Sri Lanka","Pakistan","Bhutan","Maldives","South Africa","Kenya","Nigeria","Mauritius",
  "Fiji","Japan","South Korea","China","Thailand","Indonesia","Philippines","Italy","Spain","Sweden","Norway",
  "Denmark","Finland","Switzerland","Belgium","Portugal","Russia","Brazil","Mexico","Argentina","Other",
];

// India Post free PIN lookup
export async function lookupPincode(pin) {
  if (!/^\d{6}$/.test(pin)) return null;
  try {
    const r = await fetch(`https://api.postalpincode.in/pincode/${pin}`);
    const data = await r.json();
    const first = data?.[0];
    if (first?.Status !== "Success") return null;
    const office = first.PostOffice?.[0];
    if (!office) return null;
    return {
      city: office.District || office.Block || office.Name,
      state: office.State,
      country: office.Country || "India",
      area: office.Name,
    };
  } catch { return null; }
}
